var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('menu-bar'),_vm._v(" "),(_vm.header)?_c('header-bar',{attrs:{"title":_vm.name}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-container"},[_c('router-view')],1),_vm._v(" "),_c('footer-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }